<template>
  <div class="detail">
    <div class="detail-banner">
      <img :src="articleDetail.img_url" alt="">
    </div>
    <div class="content-box">
      <div class="detail-header">
        <h2 class="detail-title"> {{ articleDetail.title }} </h2>
        <p class="news-sub"> {{ articleDetail.update_time_show }} </p>
      </div>
      <div class="detail-content" v-html="articleDetail.content">
        <!-- <p>
          上海病例数始终处在高位，大面积封控也带来了史无前例的民生压力。今天我们不想再去讨论如何防护如何隔离，因为相信大家在这场极为艰难的历程中，早已积攒了丰富的“实战”经验。只是在这个过程中，单单照顾好我们的身体还远远不够。
        </p>
        <img src="@/assets/logo.png" alt="" />
        <p>
          上海病例数始终处在高位，大面积封控也带来了史无前例的民生压力。今天我们不想再去讨论如何防护如何隔离，因为相信大家在这场极为艰难的历程中，早已积攒了丰富的“实战”经验。只是在这个过程中，单单照顾好我们的身体还远远不够。
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import newsService from '@/apis/news/index'
import moment from 'moment'

export default {
    data() {
        return {
                articleDetail: {}
        }
    },
    created() {
    document.title = '健康资讯'

            this.getArticleDetail()
    },
    methods: {
        getArticleDetail() {
            const params = {
                id: this.$route.params.id
            }
            newsService.getArticleDetail(params).then(res => {
              res.update_time_show = res.update_time ? moment(res.update_time).format('YYYY-MM') : ''
                this.articleDetail = res
            })
        }
    }
}
</script>

<style lang="less" scoped>
.detail {
  // padding: 15px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  .content-box {
    padding: 20px;
  }
}
.detail-banner {
  img {
    width: 100%;
    height: auto;
  }
}
.detail-header {
  // border-bottom: 1px solid #f0f2f6;
  border-left: 3px solid  #E7635E;
  border-radius: 3px;
  padding-left: 18px;
  box-sizing: border-box;
  .detail-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 24px;
  }
  .news-sub {
    margin: 10px 0 15px 0;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
  }
}

</style>
<style lang="less">
.detail-content {
  p {
    margin: 20px 0 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #333333 !important;
    line-height: 22px !important;
    text-align: justify;
  }
  img {
    max-width: calc(100% - 32px) !important;
    height: auto !important;
  }
}
</style>
